import styled, { css } from 'styled-components';

export const CommentCounterContainer = styled.div`
  position: absolute;
  top: calc(50% - 13px);
  right: 3px;

  padding: 2px 6px;
  cursor: pointer;
  border-radius: 8px 8px 8px 0;
  border: 1px solid #dee2e6;
  background: #fff;
  height: fit-content;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .comment-count {
    font-size: 12px;
    margin-right: 3px;
    color: #228be6;
    font-weight: bold;
  }

  ${({ $collapsed }) =>
    $collapsed &&
    css`
      top: 27px;
      right: 4px;
      left: auto;
      bottom: auto;
      padding: 0 3px;
      border-radius: 6px 6px 6px 0;
      justify-content: center;

      svg {
        width: 12px;
        height: 12px;
      }

      .comment-count {
        margin-right: 2px;
        font-size: 10px;
        line-height: 1.4;
      }
    `}
`;
